import { render, staticRenderFns } from "./SelectedProducts.component.vue?vue&type=template&id=150bd5f4&scoped=true"
import script from "./SelectedProducts.component.vue?vue&type=script&lang=js"
export * from "./SelectedProducts.component.vue?vue&type=script&lang=js"
import style0 from "./SelectedProducts.component.vue?vue&type=style&index=0&id=150bd5f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150bd5f4",
  null
  
)

export default component.exports